import apiFetch from '../apiFetch'

export default function (token, dossierSubType) {
  const type = dossierSubType ? `?dossierSubTypeId=${dossierSubType}` : ''
  return apiFetch({ endPoint: `entityType${type}`, method: 'GET', body: null, token: token })
}
